import { createBoxKitchenAppliance } from "./C1_createBoxKitchenAppliance";

const Dishwasher = createBoxKitchenAppliance({
  id: "dishwasher",
  iconKind: "dishwasher",
  description: { en: "Dishwasher", de: "Spülmaschine" },
  centerLabel: { en: "D", de: "S" },
});

export default Dishwasher;
